import PouchDB from "pouchdb";
import router from "@/router";
import { removeCookie } from "@/helpers/collections";

var db = new PouchDB("admindb");

const state = {
  role: "Admin",
  // Note: If you need compare with single the use single
  roleType: "Single", // list
  user: {},
  token: ""
};

const mutations = {
  // setuser(state, user) {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USER: (state, user) => {
    state.user = user;
    if (state.user.roleID == "6") {
      state.role = "RS";
    }
    if (state.user.roleID == "7") {
      state.role = "KSA_TRANS";
    }
    if (state.user.roleID == "8") {
      state.role = "UAE_TRANS";
    }
    if (state.user.roleID == "9") {
      state.role = "OMN_TRANS";
    }
    if (state.user.roleID == "10") {
      state.role = "BH_TRANS";
    }
    if(state.user.name == "Ranbir"){
      state.role = "RB";
    }

    if(state.user.name == "Rating"){
      state.role = "rating";
    }
    db.get("currUser")
      .then(doc => {
        db.put({
          _id: "currUser",
          _rev: doc._rev,
          user: user
        });
      })
      .catch(e => {
        if (e.status === 404) {
          db.put({
            _id: "currUser",
            user: user
          });
        } else {
          throw e;
        }
      });
  },
  REMOVE_USER: (state, user) => {
    db.get("currUser").then(function(doc) {
      return db.remove(doc);
    });
  },
  ON_LOGOUT_USER: (state, user) => {
    state.user = {};
    state.token = "";
  }
};

const actions = {
  onLoginUser: async ({ dispatch, commit, state }, payload) => {
    commit("SET_USER", payload);
  },
  onLogoutUser: async ({ dispatch, commit, state }, payload) => {
    localStorage.removeItem('userRoleId')
    await commit("ON_LOGOUT_USER", payload);
    await commit("REMOVE_USER");
    await removeCookie();
    await router.push({ path: "/login" });
  }
};
const getters = {
  getUserInfo: state => state.user,
  getRole: state => state.role
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
